export default "__VITE_ASSET___a4OeT5$__"